import { render, staticRenderFns } from "./LearningCompletedDialog.vue?vue&type=template&id=287cc4fc&scoped=true"
import script from "./LearningCompletedDialog.vue?vue&type=script&lang=js"
export * from "./LearningCompletedDialog.vue?vue&type=script&lang=js"
import style0 from "./LearningCompletedDialog.vue?vue&type=style&index=0&id=287cc4fc&prod&scoped=true&lang=css"
import style1 from "./LearningCompletedDialog.vue?vue&type=style&index=1&id=287cc4fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "287cc4fc",
  null
  
)

export default component.exports